import type { FC, ReactNode } from 'react';

import { MarcaMaestra } from '../marcas/MarcaMaestra';
import styles from './DicaDaMaestra.module.scss';

// A DICA DA MAESTRA: um conselho, e não um alerta. O aviso do Carbon (o "i" azul) lia como erro do
// sistema; a dica leva o símbolo da Maestra, com a voz de quem orienta o artista (pedido da call de
// 29/09: "Dica da Maestra", com a marca no lugar do ícone de informação).

export const DicaDaMaestra: FC<{ children: ReactNode; className?: string }> = ({ children, className }) => (
  <aside className={[styles.dica, className].filter(Boolean).join(' ')} aria-label='Dica da Maestra'>
    <span className={styles.marca} aria-hidden><MarcaMaestra forma='simbolo' /></span>
    <div className={styles.corpo}>
      <p className={styles.titulo}>Dica da Maestra</p>
      <p className={styles.texto}>{children}</p>
    </div>
  </aside>
);
